export default "__VITE_ASSET__8413ec5d__"